module.exports = __webpack_public_path__ + "assets/img/dev3.d80f0ee3.png";